import { Icon } from '@/atoms';
import { cls } from '@/utils';
import { t } from 'ttag';
import styles from './ScrollButton.module.scss';

interface Props {
	onClick: () => void;
	direction: 'up' | 'down';
	forwardedRef?: React.RefObject<HTMLDivElement>;
	show?: boolean;
}

export const ScrollButton: React.FC<Props> = ({ onClick, direction = 'down', forwardedRef, show = false }) => {
	return (
		<div
			className={cls(styles.btnWrapper, styles[`direction--${direction}`], show ? styles.show : styles.hide)}
			ref={forwardedRef}
		>
			<button
				onClick={onClick}
				className={styles.btn}
				tabIndex={show ? 0 : -1}
				aria-label={direction === 'up' ? t`Scrolla upp` : t`Scrolla ner`}
			>
				<div className={styles.iconWrapper}>
					<Icon
						name={direction === 'up' ? 'chevron-up' : 'chevron-down'}
						color="--action-color"
						className={styles.icon}
					/>
				</div>
			</button>
		</div>
	);
};
